import axios from "axios";

export async function getAllDescriptions() {
    return await axios.get(`/report/descriptions`);
}

export async function updateDescription(desc) {
    return await axios.put(`/report/descriptions`, desc);
}

export async function postDescription(desc) {
    return await axios.post(`/report/descriptions`, desc);
}

export async function deleteDescription(ids) {
    return await axios.delete(`/report/descriptions`, {
        data: ids
    });
}